export const applicantOptions = [
    {
        label: '杨剑',
        value: "杨剑",
    },
    {
        label: '赵文龙',
        value: "赵文龙",
    },
    {
        label: '冯鹏',
        value: "冯鹏",
    },
    {
        label: '丁欢',
        value: "丁欢",
    },
    {
        label: '丁健',
        value: "丁健",
    },
    {
        label: '罗同双',
        value: "罗同双",
    },
    {
        label: '孙梦为',
        value: "孙梦为",
    },
    {
        label: '王威新',
        value: "王威新",
    },
    {
        label: '黄金媚',
        value: "黄金媚",
    },
    {
        label: '黄蕾',
        value: "黄蕾",
    },
    {
        label: '苏奕光',
        value: "苏奕光",
    },
    {
        label: '黄可婷',
        value: "黄可婷",
    },
    {
        label: '周经颖',
        value: "周经颖",
    },
    {
        label: '胡林涛',
        value: "胡林涛",
    },
    {
        label: '林朝贤',
        value: "林朝贤",
    },
];
export const modelOptions = [
    {
        label: "天鹅Swan600",
        value: "天鹅Swan600"
    },
    {
        label: "天鹅Swan600P",
        value: "天鹅Swan600P"
    },
    {
        label: "天鹅Swan600周边眼轴",
        value: "天鹅Swan600周边眼轴"
    },
    {
        label: "天鹅Swan700P",
        value: "天鹅Swan700P"
    },
    {
        label: "天鸽Columba300S",
        value: "天鸽Columba300S"
    },
    {
        label: "天鸽Columba300",
        value: "天鸽Columba300"
    },
    {
        label: "天龙Draco800P",
        value: "天龙Draco800P"
    },
];

export const prototypeStatusOptions = [
    {
        label: "已归还",
        value: "已归还",
    },
    {
        label: "转销售",
        value: "转销售",
    },
    {
        label: "继续使用",
        value: "继续使用",
    },
    {
        label: "超时",
        value: "超时",
    },

];


export const customerType = [
    {
        label: "代理商",
        value: "代理商",
    },
    {
        label: "C端客户",
        value: "C端客户",
    },
    {
        label: "医院",
        value: "医院",
    },
    {
        label: "药店",
        value: "药店",
    },
    {
        label: "教育",
        value: "教育",
    },
    {
        label: "销售员自用",
        value: "销售员自用",
    },
    {
        label: "其它",
        value: "其它",
    },
];

export const machineType = [
    {
        label: "天鸽",
        value: "天鸽",
    },
    {
        label: "天鹅",
        value: "天鹅",
    },
    {
        label: "蓝鲸",
        value: "蓝鲸",
    },
    {
        label: "星豚",
        value: "星豚",
    },
    {
        label: "天龙",
        value: "天龙",
    },
    {
        label: "其他",
        value: "其他",
    },
];

export const prototypeMachineStatus = [
    {
        label: "未激活",
        value: 1,
    },
    {
        label: "客户试用",
        value: 2,
    },
    {
        label: "到期",
        value: 3,
    },
    {
        label: "样机转销售机",
        value: 4,
    },
    {
        label: "结束",
        value: 5,
    },

];

export const loDepartment = ['视光营销事业部', '医疗市场部', '客户服务部', '研发中心', '创新项目部'];
